import { useQuery } from 'react-query';
import * as RestApi from 'core/network/RestApi';
import { generatePath } from 'react-router';
import { ISelectOption } from '@salecycle/ui-component-library';
export enum EnrichmentEndpoints {
  GET_ENRICHMENTS = '/enrichments',
  GET_SITE_ENRICHMENTS = '/sites/:siteId/enrichments/settings',
}

export const EnrichmentList = (): ISelectOption<string>[] => {
  const getEnrichmentsQuery = useQuery(['get_enrichments'], async () => {
    const result = await RestApi.get<string[]>(generatePath(EnrichmentEndpoints.GET_ENRICHMENTS));
    return result.data;
  });
  const enrichmentList = getEnrichmentsQuery?.data ?? null;
  if (Array.isArray(enrichmentList)) {
    return enrichmentList.map(enrich => ({
      value: enrich,
      label: enrich,
    }));
  }
};

export const SiteEnrichmentList = (siteId: string): ISelectOption<string>[] => {
  const getEnrichmentsQuery = useQuery(
    ['get_site_enrichments', siteId],
    async () => {
      const url = generatePath(EnrichmentEndpoints.GET_SITE_ENRICHMENTS, { siteId: siteId as string });
      const result = await RestApi.get(url);
      return result.data;
    },
    { enabled: Boolean(siteId) },
  );

  const enrichmentList = getEnrichmentsQuery?.data ?? null;
  if (Array.isArray(enrichmentList)) {
    return enrichmentList.map(enrich => ({
      value: enrich.enrichment,
      label: enrich.enrichment,
    }));
  }
  return [];
};
